/* All purchasing is handled by Dawn's native Shopify forms. */
(() => {
  const wireNavigation = (root = document) => {
    root.querySelectorAll('.cv-nav-details').forEach(details => {
      if (details.dataset.ready) return;
      details.dataset.ready = 'true';
      details.addEventListener('toggle', () => {
        if (details.open) root.querySelectorAll('.cv-nav-details[open]').forEach(other => { if (other !== details) other.open = false; });
      });
      details.addEventListener('keydown', event => {
        if (event.key === 'Escape') { details.open = false; details.querySelector('summary').focus(); }
      });
      details.addEventListener('focusout', () => setTimeout(() => {
        if (!details.contains(document.activeElement)) details.open = false;
      }, 0));
    });
  };
  wireNavigation();
  document.addEventListener('shopify:section:load', event => wireNavigation(event.target));
  document.addEventListener('click', event => {
    document.querySelectorAll('.cv-nav-details[open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  if (document.querySelector('.cv-mobile-purchase')) document.body.classList.add('cv-has-product');
  if (!customElements.get('cv-product-edit')) customElements.define('cv-product-edit', class extends HTMLElement {
    async connectedCallback() {
      if (!this.dataset.newestUrl || this.dataset.loaded) return;
      this.dataset.loaded = 'true';
      try {
        const url = new URL(this.dataset.newestUrl, location.origin);
        url.searchParams.set('sort_by', 'created-descending');
        url.searchParams.set('section_id', 'cv-new-arrivals-feed');
        const response = await fetch(url);
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const grid = doc.querySelector('.product-grid');
        if (!grid || !grid.children.length) return;
        const limit = this.querySelectorAll(':scope > ul > li').length || 4;
        while (grid.children.length > limit) grid.lastElementChild.remove();
        // Avoid duplicate quick-add modal IDs if more than one arrival edit is configured.
        grid.innerHTML = grid.innerHTML.replaceAll('cv-new-arrivals-feed', this.dataset.section);
        this.replaceChildren(grid);
      } catch (_) { /* Keep the server-rendered catalog fallback. */ }
    }
  });
  if (!customElements.get('cv-recently-viewed')) customElements.define('cv-recently-viewed', class extends HTMLElement {
    async connectedCallback() {
      if (this.dataset.loaded) return;
      this.dataset.loaded = 'true';
      try {
        let history = JSON.parse(sessionStorage.getItem('cv-recent') || '[]');
        if (!Array.isArray(history)) history = [];
        history = history.filter(h => typeof h === 'string' && /^[a-z0-9-]+$/.test(h) && h !== this.dataset.handle).slice(0, 4);
        sessionStorage.setItem('cv-recent', JSON.stringify([this.dataset.handle, ...history].filter(Boolean)));
        const cards = await Promise.all(history.map(async handle => {
          const url = `${this.dataset.root}products/${encodeURIComponent(handle)}?section_id=cv-product-card-feed`;
          const response = await fetch(url);
          if (!response.ok) return null;
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          return doc.querySelector('.grid__item');
        }));
        const valid = cards.filter(Boolean);
        if (valid.length) { this.querySelector('ul').replaceChildren(...valid); this.hidden = false; }
      } catch (_) { /* Storage disabled: omit this optional section. */ }
    }
  });
})();
